export const isLocal = (url = window.location.port) => {
  return Boolean(url)
}

export const isDev = (origin = window.location.origin) => {
  return origin.indexOf('www.dev') > -1
}

export const isQa = (origin = window.location.origin) => {
  return origin.indexOf('www.qa') > -1
}

export const isQaWs1 = (origin = window.location.origin) => {
  return origin.indexOf('www-ws1.qa') > -1
}
export const isQaWs2 = (origin = window.location.origin) => {
  return origin.indexOf('www-ws2.qa') > -1
}

export const isQaWs3 = (origin = window.location.origin) => {
  return origin.indexOf('www-ws3.qa') > -1
}

export const isQaWs4 = (origin = window.location.origin) => {
  return origin.indexOf('www-ws4.qa') > -1
}

export const isQaWs5 = (origin = window.location.origin) => {
  return origin.indexOf('www-ws5.qa') > -1
}

export const isPreview = (href = window.location.href) => {
  return href.indexOf('www-preview.') > -1 || href.indexOf('/preview') > -1
}

export const isPreprod = (origin = window.location.origin) => {
  return origin.indexOf('www-preprod.') > -1
}

export const isProduction = (origin = window.location.origin) => {
  return (
    origin.indexOf('www.columbia') > -1 ||
    origin.indexOf('www-preview.') > -1 ||
    origin.indexOf('www-preprod.') > -1
  )
}

export const isProduct = (pathname = window.location.pathname) => {
  return pathname.indexOf('/strategies-solutions') > -1
}

export const isIntegratedProduct = (pathname = window.location.pathname) => {
  return pathname.indexOf('/integrated-equity') > -1
}

export const getEnv = () => {
  if (isLocal()) {
    return 'local'
  } else if (isDev()) {
    return 'dev'
  } else if (isQaWs1()) {
    return 'qaWs1'
  } else if (isQaWs2()) {
    return 'qaWs2'
  } else if (isQaWs3()) {
    return 'qaWs3'
  } else if (isQaWs4()) {
    return 'qaWs4'
  } else if (isQaWs5()) {
    return 'qaWs5'
  } else if (isQa()) {
    return 'qa'
  } else if (isPreview()) {
    return 'preview'
  } else if (isPreprod()) {
    return 'preprod'
  } else if (isProduction()) {
    return 'production'
  } else {
    return undefined
  }
}
